import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FilterCallback } from 'src/app/shared/base-reporting/models/filter-callback.interface';
import { FilterItem } from 'src/app/shared/base-reporting/models/filter-item.interface';
import { RowActionCallback } from 'src/app/shared/base-reporting/models/row-action-callback.interface';
import { RowAction } from 'src/app/shared/base-reporting/models/row-actions.interface';
import { DestinationsService } from '../destinations.service';

@Component({
  selector: 'app-destinations-log',
  templateUrl: './destinations-log.component.html',
  styleUrls: ['./destinations-log.component.css'],
})
export class DestinationsLogComponent implements OnInit {
  get data(): Array<TableViewItem> {
    return this.Data.filter((row) => {
      if (this.currentFilterObject.featured) {
        return row.featured
          .toLowerCase()
          .includes(this.currentFilterObject.featured.toLowerCase());
      }
      return true;
    }).filter((row) => {
      if (this.currentFilterObject.destinationName) {
        return row.destinationName
          .toLowerCase()
          .includes(this.currentFilterObject.destinationName.toLowerCase());
      }
      return true;
    });
  }
 
  set data(v: Array<TableViewItem>) {
    this.Data = v;
  }
  private Data = [] as Array<TableViewItem>;

  tableColumns = [
    'destinationName',
    'featured',
  ];

  reportFilter: Array<FilterItem> = [
    {
      fieldName: 'destinationName',
      fieldDisplayName: 'Destination Name ',
      fieldType: 'text',
    },
    {
      fieldName: 'featured',
      fieldDisplayName: 'Featured',
      fieldType: 'select',
      multiple: false,
      hasSelectAll: false,
      defaultValue: null,
      options: [
        { value: null, display: 'Not Assigned' },
        { value: 'true', display: 'Activated' },
        { value: 'false', display: 'Deactivated' },
      ],
    },
  ];

  constructor(
    private destinationService: DestinationsService,
    private router: Router
  ) {}

  currentFilterObject = {} as FilterModel;
  rowActions: Array<RowAction> = [
    {
      type: 'icon',
      slug: 'editDestination',
      class: 'btn',
      iconClasses: 'fa fa-edit',
    },
  ];

  ngOnInit() {
    this.fetchAllDestinations();
  }

  onFilter(event: FilterCallback) {
    this.currentFilterObject = event.filter;
  }

  private fetchAllDestinations() {
    this.destinationService.getAllDestinations().subscribe((response) => {
      console.log(response);
      this.data = response.data.destinations.map((r) => {
        console.log(r);
        // console.log(destination);
        return {
          id: r.id,
          destinationName: r.name,
          featured: r.featured.toString()
        } as TableViewItem;
      });
    });
  }
  rowActionCB(event: RowActionCallback) {
    switch (event.action) {
      case 'editDestination':
        this.editDestination(event.on.id);
        break;
      default:
        console.error('this is a mistake!');
    }
  }
  editDestination(id) {
    this.router.navigate(['/destinations/edit/' + id]);
  }
}

interface TableViewItem {
  id: number;
  destinationName: string;
  featured: string;
}

interface FilterModel {
  featured: string;
  destinationName: string;
}
